import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { AuditorRegistrationDetail } from '../types';

export const getAuditorRegistrationById = async (
  id: string
): Promise<AuditorRegistrationDetail> => {
  const fetchResponse = await fetch(`${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-regs/${id}`, {
    method: 'GET',
    headers: {
      authenticate: localStorage.getItem('accessToken') || '',
    },
  });

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditorRegistrationDetail;
  return response;
};
